webpackJsonp([162898551421021],{

/***/ 195:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var localization = {
	  nl: {
	    title: 'Pagina niet gevonden'
	  },
	  de: {
	    title: 'Site nicht gefunden'
	  },
	  en: {
	    title: 'Page not found'
	  }
	};
	
	exports.default = localization;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContentBlock = __webpack_require__(10);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _ = __webpack_require__(195);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage(props) {
	  var language = props.language;
	
	
	  return _react2.default.createElement(
	    _ContentBlock2.default,
	    { darkBackground: true },
	    _react2.default.createElement(
	      'h1',
	      { className: 't-heading-xl' },
	      _2.default[language].title
	    )
	  );
	};
	
	NotFoundPage.propTypes = {
	  language: _propTypes2.default.string.isRequired
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-08d659dd7979d082746a.js